import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Button from '../../Button';

interface Props {
  title: string;
  /** Optional one-line description rendered beside the title. */
  subtitle?: string;
  onBack?: () => void;
  /** Optional eyebrow rendered above the title — e.g. "Operate · Logistics". */
  eyebrow?: string;
  primaryAction?: React.ReactNode;
}

export default function PageHeader({
  title,
  subtitle,
  onBack,
  eyebrow,
  primaryAction,
}: Props) {
  return (
    <header className="admin-page-header">
      {onBack && (
        <Button
          variant="tertiary"
          size="sm"
          iconOnly
          className="admin-page-header__back"
          onClick={onBack}
          aria-label="Go back"
        >
          <ArrowLeftIcon
            className="admin-page-header__back-icon"
            aria-hidden="true"
          />
        </Button>
      )}
      <div className="admin-page-header__lede">
        {eyebrow && (
          <span className="admin-page-header__eyebrow">{eyebrow}</span>
        )}
        <h1 className="admin-page-header__title">{title}</h1>
        {subtitle && (
          <p className="admin-page-header__subtitle">{subtitle}</p>
        )}
      </div>
      {primaryAction && (
        <div className="admin-page-header__action">{primaryAction}</div>
      )}
    </header>
  );
}
